export default __webpack_public_path__ + "static/media/create-workspace.2a2b44d1.svg";